import { render, staticRenderFns } from "./BaseRqUsuarios.vue?vue&type=template&id=c25c9e52&scoped=true&"
import script from "./BaseRqUsuarios.vue?vue&type=script&lang=js&"
export * from "./BaseRqUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./BaseRqUsuarios.vue?vue&type=style&index=0&id=c25c9e52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25c9e52",
  null
  
)

export default component.exports